import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { Search, Loader2 } from "lucide-react";

export default function MasterAudit() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async (q) => {
    setLoading(true);
    try {
      const { data } = await api.get("/master/audit", { params: { action: q || undefined, limit: 200 } });
      setItems(data.items || []);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="p-6 md:p-10 max-w-7xl">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground">Histórico de alterações</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-1">Tudo o que acontece na plataforma</h1>
        <p className="text-sm text-muted-foreground mt-1">Tudo o que acontece — qualquer ator, qualquer tenant.</p>
      </div>

      <div className="mb-4 max-w-md relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input placeholder="Filtrar por ação (ex: tenant.created)" value={filter}
          onChange={(e) => setFilter(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && load(filter)} className="pl-9" />
      </div>

      <Card className="rounded-xl border-border bg-card overflow-hidden">
        {loading ? <div className="p-10 text-muted-foreground"><Loader2 className="w-4 h-4 animate-spin" /></div> :
          items.length === 0 ? <div className="p-10 text-center text-muted-foreground">Sem registros.</div> :
          (
            <table className="w-full text-sm">
              <thead className="bg-muted/40 text-xs uppercase tracking-wider text-muted-foreground">
                <tr>
                  <th className="text-left px-5 py-3 font-medium">Quando</th>
                  <th className="text-left px-5 py-3 font-medium">Ação</th>
                  <th className="text-left px-5 py-3 font-medium">Quem fez</th>
                  <th className="text-left px-5 py-3 font-medium">Empresa</th>
                  <th className="text-left px-5 py-3 font-medium">Item afetado</th>
                </tr>
              </thead>
              <tbody>
                {items.map((a) => (
                  <tr key={a.id} className="border-t border-border">
                    <td className="px-5 py-2.5 text-xs whitespace-nowrap">{new Date(a.created_at).toLocaleString("pt-BR")}</td>
                    <td className="px-5 py-2.5 font-medium">{a.action}</td>
                    <td className="px-5 py-2.5 text-muted-foreground">{a.actor_email || "—"} <span className="text-xs">({a.actor_role || "?"})</span></td>
                    <td className="px-5 py-2.5 text-xs font-mono">{a.tenant_id ? a.tenant_id.slice(0, 8) : "global"}</td>
                    <td className="px-5 py-2.5 text-xs">{a.resource}{a.resource_id ? ` · ${a.resource_id.slice(0, 8)}` : ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
      </Card>
    </div>
  );
}
